import { Grid3X3, List } from "lucide-react";
import { useState } from "react";
import { Button } from "@jambushrushti/components/ui/button";

export type AdminViewMode = "cards" | "table";

interface AdminViewToggleProps {
  value: AdminViewMode;
  onChange: (value: AdminViewMode) => void;
}

export function AdminViewToggle({ value, onChange }: AdminViewToggleProps) {
  return (
    <div
      className="inline-flex overflow-hidden rounded-lg border border-primary/20 bg-primary p-1 shadow-sm"
      aria-label="View mode"
    >
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Card view"
        aria-label="Card view"
        className={`h-8 w-8 rounded-md p-0 ${value === "cards" ? "bg-card text-primary shadow-sm hover:bg-card" : "text-primary-foreground hover:bg-white/15 hover:text-primary-foreground"}`}
        onClick={() => onChange("cards")}
      >
        <Grid3X3 className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Table view"
        aria-label="Table view"
        className={`h-8 w-8 rounded-md p-0 ${value === "table" ? "bg-card text-primary shadow-sm hover:bg-card" : "text-primary-foreground hover:bg-white/15 hover:text-primary-foreground"}`}
        onClick={() => onChange("table")}
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  );
}

export function getInitialAdminView(): AdminViewMode {
  return localStorage.getItem("adminContentView") === "cards"
    ? "cards"
    : "table";
}

export function saveAdminView(value: AdminViewMode) {
  localStorage.setItem("adminContentView", value);
}

export function useAdminViewMode() {
  const [viewMode, setViewModeState] =
    useState<AdminViewMode>(getInitialAdminView);
  const setViewMode = (value: AdminViewMode) => {
    setViewModeState(value);
    saveAdminView(value);
  };
  return [viewMode, setViewMode] as const;
}
